import type { ItemContent as VirtuosoItemContent } from 'react-virtuoso';
import { DateSeparator } from '../date-separator/date-separator';

import type { VirtuosoContext } from '../../lib/types';
import { MessageItem } from '../message-item/message-item';
import type { UiMessage } from '../../virtualized-messages-list';

export const ItemContent: VirtuosoItemContent<UiMessage, VirtuosoContext> = (
  _,
  message,
  context,
) => {
  const {
    clientName,
    clientAvatar,
    agentNamesById,
    switchNoticePrefix,
    switchNoticeTooltip,
    aiAgentLabel,
    onChangeMessage,
  } = context;

  return (
    <>
      {message.showDateSeparator && <DateSeparator date={message.created_at} />}
      <MessageItem
        message={message}
        clientName={clientName}
        clientAvatar={clientAvatar}
        agentNamesById={agentNamesById}
        switchNoticePrefix={switchNoticePrefix}
        switchNoticeTooltip={switchNoticeTooltip}
        aiAgentLabel={aiAgentLabel}
        onChange={onChangeMessage}
      />
    </>
  );
};
